import React, { useState, useEffect } from 'react';
import { get, isEmpty } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTestOMR } from '../../../../actions/performanceAnalysisActions';
import { dateFormat } from '../../../../api/dateFormat';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import PerfectScrollbar from 'react-perfect-scrollbar';
import PropTypes from 'prop-types';
import useWindowDimensions from '../../../../components/Dimension';
import { Skeleton } from '@material-ui/lab';
//import { dateFormat } from 'app/api/methods/dateFormat';

export default function ViewORSSheet(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isFetching, setIsFetching] = React.useState(true);
  const [paperObj, setPaperObj] = useState({
    key: 'paper1',
    value: 'Paper- 01',
  });
  //Redux
  const dispatch = useDispatch();
  //window height
  const { height } = useWindowDimensions();

  const jwtToken = useSelector((state) =>
    get(state, 'loginReducer.data.jwt', '')
  );

  const testOMR = useSelector((state) =>
    get(state, 'performanceAnalysisReducer.testOMR', [])
  );
  const paper =
    paperObj.key === 'paper1'
      ? useSelector((state) =>
          get(state, 'performanceAnalysisReducer.testOMR.paper1', [])
        )
      : useSelector((state) =>
          get(state, 'performanceAnalysisReducer.testOMR.paper2', [])
        );
  const paper2 = useSelector((state) =>
    get(state, 'performanceAnalysisReducer.testOMR.paper2', [])
  );
  useEffect(() => {
    setIsFetching(true);
    fetchTestOMR(jwtToken, props.testID, dispatch).then(() => {
      setIsFetching(false);
    });
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (key, val) => {
    setAnchorEl(null);
    if (val !== 'backdropClick') {
      setPaperObj({
        key: key,
        value: val,
      });
    }
  };

  return (
    <React.Fragment>
      <div className="list-content flex">
        {(isFetching || (!isEmpty(testOMR) && !isEmpty(paper))) && (
          <div className="list-header">
            <h3 className="mb-5">
              {isFetching ? <Skeleton width="100px" /> : paper.TestName}
            </h3>
            {(isFetching || (!isEmpty(paper) && paper.TestDate)) && (
              <p className="sub-text">
                {isFetching ? (
                  <Skeleton width="50px" />
                ) : (
                  dateFormat(paper.TestDate)
                )}
              </p>
            )}
          </div>
        )}
        {(isFetching || (!isEmpty(testOMR) && !isEmpty(paper2) && props.paper2Exist)) && (
          <div className="paper-box">
            {isFetching ? (
              <Skeleton width="60px" />
            ) : 
              <Button
                variant="outlined"
                aria-controls="simple-menu"
                aria-haspopup="true"
                onClick={handleClick}
              >
                {paperObj.value}
                <span className="caret ml-10" />
              </Button>
            }
          </div>
        )}
      </div>
      <div className="slider-wrapper" style={{ height: height - 140 }}>
        <PerfectScrollbar>
          {isFetching ? (
            <Skeleton width="95%" height="700px" />
          ) : (
            <img
              src={paper.OMRUrl}
              alt={paper.TestName + ' ORS PAPER'}
              className="img-responsive"
            />
          )}
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem onClick={() => handleClose('paper1', 'Paper- 1')}>
              Paper- 1
            </MenuItem>
            <MenuItem onClick={() => handleClose('Paper2', 'Paper- 2')}>
              Paper -2
            </MenuItem>
          </Menu>
        </PerfectScrollbar>
      </div>
    </React.Fragment>
  );
}
ViewORSSheet.propTypes = {
  testID: PropTypes.string,
  paper2Exist: PropTypes.bool,
};
